module.exports = {
  XmlEntities: require('./lib/xml-entities.js'),
  Html4Entities: require('./lib/html4-entities.js'),
  Html5Entities: require('./lib/html5-entities.js'),
  AllHtmlEntities: require('./lib/html5-entities.js')
};



//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/Wordpress-Aude-Olivier/wp-content/themes/aude-olivier/node_modules/html-entities/index.js
// module id = 12
// module chunks = 0 1